import { pulse } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

export const imagePlaceholder = css`
  display: block;
  text-indent: -99999rem;
  ${pulse}
`;
